<div class="nav-panel" [class.nav-panel--compact]="compact">
  <div class="logo-row">
    <a routerLink="/home" class="brand">
      <img
        src="/time-tracker-logo.svg"
        alt="Time Tracker Logo"
        class="site-logo"
      />
      <span class="brand-name nav-expandable-text">Time Tracker</span>
    </a>
  </div>

  <div class="menu">
    @if (showLogTime()) {
      <a
        routerLink="/home"
        routerLinkActive="active"
        #homeActive="routerLinkActive"
        class="menu-item"
        ngbTooltip="Home"
        [disableTooltip]="!compact"
        placement="end"
        container="body"
        triggers="hover"
      >
        <span class="menu-item-icon" aria-hidden="true">
          <i
            class="bi"
            [class.bi-house-door]="!homeActive.isActive"
            [class.bi-house-door-fill]="homeActive.isActive"
          ></i>
        </span>
        <span class="label nav-expandable-text">Home</span>
      </a>
      <a
        routerLink="/time-sheet"
        routerLinkActive="active"
        #timeSheetActive="routerLinkActive"
        class="menu-item"
        ngbTooltip="Time Sheets"
        [disableTooltip]="!compact"
        placement="end"
        container="body"
        triggers="hover"
      >
        <span class="menu-item-icon" aria-hidden="true">
          <i
            class="bi"
            [class.bi-stopwatch]="!timeSheetActive.isActive"
            [class.bi-stopwatch-fill]="timeSheetActive.isActive"
          ></i>
        </span>
        <span class="label nav-expandable-text">Time Sheets</span>
      </a>
    }
    @if (showAnalytics()) {
      <a
        routerLink="/analytics"
        routerLinkActive="active"
        #analyticsActive="routerLinkActive"
        class="menu-item"
        ngbTooltip="Analytics"
        [disableTooltip]="!compact"
        placement="end"
        container="body"
        triggers="hover"
      >
        <span class="menu-item-icon" aria-hidden="true">
          <i
            class="bi"
            [class.bi-bar-chart]="!analyticsActive.isActive"
            [class.bi-bar-chart-fill]="analyticsActive.isActive"
          ></i>
        </span>
        <span class="label nav-expandable-text">Analytics</span>
      </a>
    }
    @if (admin()) {
      <a
        routerLink="/projects"
        routerLinkActive="active"
        #projectsActive="routerLinkActive"
        class="menu-item"
        ngbTooltip="Projects"
        [disableTooltip]="!compact"
        placement="end"
        container="body"
        triggers="hover"
      >
        <span class="menu-item-icon" aria-hidden="true">
          <i
            class="bi"
            [class.bi-folder]="!projectsActive.isActive"
            [class.bi-folder-fill]="projectsActive.isActive"
          ></i>
        </span>
        <span class="label nav-expandable-text">Projects</span>
      </a>
    }
  </div>

  <div class="footer">
    <app-side-nav-profile-card [compact]="compact" (logout)="logout.emit()" />
  </div>
</div>
